import { FC } from 'react';
import { ValueFormatterParams } from 'ag-grid-community';
import {
    Buttons,
    Page,
    TableWrapper
} from "../../../../common/TableWithButtonsRightLayout/TableWithButtonsRightLayout.styles";
import Table from "../../../../components/Table/Table";
import Export from "../../../../components/Export/Export";
import { ConfirmationProps } from "./Confirmation.types";
import { DeleteOptionRecipeResponse } from '../../../../services/option/option.types';

const Confirmation: FC<ConfirmationProps> = ({
                                                 deletedOptionRecipes
                                             }) => {
    const columnDefs = [
        {headerName: 'Spec', field: 'subRecipe.specNo', minWidth: 120, maxWidth: 220, flex: 1},
        {headerName: 'Sub-Spec', field: 'subRecipe.subSpecNo', minWidth: 120, maxWidth: 220, flex: 1},
        {headerName: 'Class', field: 'subRecipe.classDescription', minWidth: 200, maxWidth: 300, flex: 2},
        {headerName: 'Base', field: 'subRecipe.baseDescription', minWidth: 200, maxWidth: 300, flex: 2},
        {headerName: 'Size', field: 'subRecipe.sizeDescription', minWidth: 200, maxWidth: 300, flex: 2},
        {headerName: 'Product', field: 'subRecipe.productDescription', minWidth: 200, maxWidth: 300, flex: 2},
        {headerName: 'Option', field: 'subRecipe.optionDescription', minWidth: 200, maxWidth: 300, flex: 2},
        {headerName: 'Status', field: 'status', minWidth: 220, flex: 1},
        {
            headerName: 'Date/Time', field: 'dateTime', minWidth: 220, flex: 1, resizable: false,
            valueFormatter: (params: ValueFormatterParams) =>
                `${new Date(params.value).toLocaleDateString()} ${new Date(params.value).toLocaleTimeString()}`,
        }
    ];

    const normalizeObject = (deleteOptionRecipe: DeleteOptionRecipeResponse) => {
      return {
        specNo: deleteOptionRecipe.subRecipe.specNo,
        subSpecNo: deleteOptionRecipe.subRecipe.subSpecNo,
        classDescription: deleteOptionRecipe.subRecipe.classDescription,
        baseDescription: deleteOptionRecipe.subRecipe.baseDescription,
        sizeDescription: deleteOptionRecipe.subRecipe.sizeDescription,
        productDescription: deleteOptionRecipe.subRecipe.productDescription,
        optionDescription: deleteOptionRecipe.subRecipe.optionDescription,
        status: deleteOptionRecipe.status,
        dateTime: deleteOptionRecipe.dateTime
      }
    }

    return (
        <Page data-testid='ConfirmationPage'>
            <TableWrapper>
                <Table
                    floatingFiltersHeight={0}
                    rowData={deletedOptionRecipes}
                    returnedRecords={deletedOptionRecipes?.length}
                    columnDefs={columnDefs}
                />
            </TableWrapper>
            <Buttons>
                <Export
                    columnHeaders={columnDefs.map((col) => {
                        const field = col.field.replace('subRecipe.','');
                        return {field: field, headerName: col.headerName};
                    })}
                    rowData={deletedOptionRecipes?.map(normalizeObject) || []}
                />
            </Buttons>
        </Page>
    );
};

export default Confirmation;